import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable()
export class SwapService {
  constructor(private http: HttpService) {}

  getSwaps(
    page: number = 1,
    page_size: number = 10,
    wallet_id: any = null,
    provider_id: any = null,
    client_id: any = null,
  ) {
    let params = new HttpParams()
      .set('page', String(page))
      .set('page_size', String(page_size));

    if (wallet_id != null) {
      params = params.set('wallet_id', String(wallet_id));
    }

    if (provider_id != null) {
      params = params.set('provider_id', String(provider_id));
    }

    if (client_id != null) {
      params = params.set('user_id', String(client_id));
    }

    return this.http.get('sales/minimized', params);
  }

  saveExchange(body: any) {
    return this.http.post('sale/build', body);
  }

  editExchange(body: any) {
    return this.http.post('update_status_sales', body);
  }

  deleteExchange(id: number) {
    return this.http.delete('exchange/' + id);
  }
}
